import CureOutlayPage from './CureOutlayPage'
export default CureOutlayPage


// WEBPACK FOOTER //
// ./src/pages/outlay/cure/index.js